import type { SVGProps } from "react";

export const Weaviate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="weaviate_logos"
    version="1.1"
    viewBox="0 0 152.4 106"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Weaviate</title>
    <defs>
      <linearGradient
        gradientTransform="translate(0 2433.9)"
        gradientUnits="userSpaceOnUse"
        id="linear-gradient"
        x1="84.2"
        x2="72.6"
        y1="-2328.6"
        y2="-2442.5"
      >
        <stop offset="0" stopColor="#75be2c" />
        <stop offset=".9" stopColor="#9dc03b" />
      </linearGradient>
      <linearGradient
        gradientTransform="translate(0 2433.9)"
        gradientUnits="userSpaceOnUse"
        id="linear-gradient1"
        x1="78.7"
        x2="78.7"
        y1="-2376.1"
        y2="-2338.8"
      >
        <stop offset="0" stopColor="#238d37" />
        <stop offset=".9" stopColor="#35537f" />
      </linearGradient>
      <linearGradient
        gradientTransform="translate(0 2433.9)"
        gradientUnits="userSpaceOnUse"
        id="linear-gradient2"
        x1="74.7"
        x2="80.5"
        y1="-2395.4"
        y2="-2357.4"
      >
        <stop offset="0" stopColor="#67d84d" />
        <stop offset="1" stopColor="#348522" />
      </linearGradient>
      <linearGradient
        gradientTransform="translate(0 2433.9)"
        gradientUnits="userSpaceOnUse"
        id="linear-gradient3"
        x1="132.4"
        x2="132.4"
        y1="-2425.4"
        y2="-2359.2"
      >
        <stop offset="0" stopColor="#e4d00a" />
        <stop offset=".6" stopColor="#c4d132" />
      </linearGradient>
      <linearGradient
        gradientTransform="translate(0 2433.9)"
        gradientUnits="userSpaceOnUse"
        id="linear-gradient4"
        x1="24.8"
        x2="24.8"
        y1="-2425.4"
        y2="-2359.2"
      >
        <stop offset="0" stopColor="#e4d00a" />
        <stop offset=".6" stopColor="#c4d132" />
      </linearGradient>
      <linearGradient
        gradientTransform="translate(0 2433.9)"
        gradientUnits="userSpaceOnUse"
        id="linear-gradient5"
        x1="117.3"
        x2="117.3"
        y1="-2358.4"
        y2="-2336.3"
      >
        <stop offset="0" stopColor="#8ab11b" />
        <stop offset="1" stopColor="#6eaf02" />
      </linearGradient>
      <linearGradient
        gradientTransform="translate(0 2433.9)"
        gradientUnits="userSpaceOnUse"
        id="linear-gradient6"
        x1="133.3"
        x2="128.7"
        y1="-2385.1"
        y2="-2347.9"
      >
        <stop offset="0" stopColor="#75be2c" />
        <stop offset=".9" stopColor="#9dc03b" />
      </linearGradient>
      <linearGradient
        gradientTransform="translate(0 2433.9)"
        gradientUnits="userSpaceOnUse"
        id="linear-gradient7"
        x1="40"
        x2="40"
        y1="-2358.3"
        y2="-2336.4"
      >
        <stop offset="0" stopColor="#8ab11b" />
        <stop offset="1" stopColor="#6eaf02" />
      </linearGradient>
      <linearGradient
        gradientTransform="translate(0 2433.9)"
        gradientUnits="userSpaceOnUse"
        id="linear-gradient8"
        x1="28.4"
        x2="23.8"
        y1="-2384.9"
        y2="-2340.2"
      >
        <stop offset="0" stopColor="#75be2c" />
        <stop offset=".9" stopColor="#9dc03b" />
      </linearGradient>
    </defs>
    <g>
      <path
        d="M147.6,24.3l-25.5-14.8c-4.3-2.5-9.7.6-9.7,5.6v37.5l-18.1-10.4c-9.7-5.6-21.7-5.6-31.4,0l-18.1,10.4V15c0-5-5.4-8-9.7-5.6l-25.5,14.9c-3,1.7-4.8,4.9-4.8,8.3v35.3c0,2.5.6,4.8,1.8,6.9h0c1.2,2.1,2.8,3.9,4.9,5.3l13.2,8.4,10.1,6.4c6.1,3.9,13.8,3.5,19.6-.8l.8-.6c0,0,.1-.1.2-.2l15.2-11.6c4.4-3.4,11.7-3.4,16.2,0l15.1,11.5s0,0,0,0l.9.7c5.7,4.3,13.5,4.6,19.6.8l10.1-6.4,13.2-8.4c2.1-1.3,3.8-3.2,4.9-5.3s1.8-4.4,1.8-6.9v-35.2h0c0-3.4-1.8-6.6-4.8-8.3h0Z"
        style={{ fill: "url(#linear-gradient)" }}
      />
      <path
        d="M112.6,75.4v12.7c0,3.9-2.8,7.1-6.2,7.1s-3-.7-4.6-1.9l-15.1-11.6c-4.4-3.4-11.7-3.4-16.2,0l-15.2,11.6c-1.5,1.1-2.5,1.5-3.9,1.5-3.5,0-6.7-2.6-6.7-6.8v-12.6l21.7-14c7.4-4.8,17-4.8,24.4,0l21.8,13.7v.3h0Z"
        style={{ fill: "url(#linear-gradient1)" }}
      />
      <path
        d="M112.4,52.5v23.1c0,0-21.5-13.8-21.5-13.8-7.4-4.8-16.9-4.8-24.4,0l-21.7,13.8v-23.1s18.1-10.4,18.1-10.4c9.7-5.6,21.6-5.6,31.4,0l18.1,10.4h0Z"
        style={{ fill: "url(#linear-gradient2)" }}
      />
      <path
        d="M152.4,32.6v35.2c0,2.5-.6,4.8-1.8,6.9l-38.2-22.2V15c0-5,5.4-8,9.7-5.6l25.5,14.8c3,1.7,4.8,4.9,4.8,8.3h0Z"
        style={{ fill: "url(#linear-gradient3)" }}
      />
      <path
        d="M44.8,15v37.6L6.6,74.8c-1.2-2.1-1.8-4.4-1.8-6.9v-35.3c0-3.4,1.8-6.6,4.8-8.3l25.5-14.8c4.3-2.5,9.7.6,9.7,5.6h0Z"
        style={{ fill: "url(#linear-gradient4)" }}
      />
      <path
        d="M105.9,94.7c3.4,0,6.6-2.7,6.6-6.5v-12.7s20.2,12.9,20.2,12.9l-10.2,6.5c-6.1,3.9-13.9,3.6-19.6-.8l-1-.8c1.4,1,2.6,1.4,4,1.4h0Z"
        style={{ fill: "url(#linear-gradient5)" }}
      />
      <path
        d="M150.6,74.8c-1.1,2.1-2.8,3.9-4.9,5.3l-13.2,8.4-20.1-12.8v-23.1c0,0,38.2,22.3,38.2,22.3h0Z"
        style={{ fill: "url(#linear-gradient6)" }}
      />
      <path
        d="M44.8,88.2c0,3.9,3.2,6.9,6.6,6.5,1.5-.2,2.7-.4,3.9-1.3l-.9.7c-5.7,4.3-13.5,4.6-19.6.8l-10.1-6.4h0s20.1-12.9,20.1-12.9v12.6h0Z"
        style={{ fill: "url(#linear-gradient7)" }}
      />
      <path
        d="M44.8,52.5v23.1l-20.1,12.9h0s-13.2-8.4-13.2-8.4c-2.1-1.3-3.8-3.2-4.9-5.3l38.2-22.2h0Z"
        style={{ fill: "url(#linear-gradient8)" }}
      />
    </g>
  </svg>
);

export default Weaviate;
